/**
 * Utilitaire pour gérer les paramètres d'URL lors de la navigation vers les lots.
 * Les filtres de liste sont désormais persistés via filterStorageService (localStorage).
 * On ne passe plus que le chemin d'origine ("from") pour permettre le retour arrière.
 */

/**
 * Construit l'URL d'un lot avec le paramètre "from" pointant vers la liste d'origine.
 * La valeur de "from" est le chemin de la route courante (ex: /parc-immobilier).
 * Les filtres actifs sont restaurés automatiquement par le router via filterStorageService.
 *
 * @param {String} path - Le chemin cible (ex: /dossier/123/timeline)
 * @param {Object} route - L'objet route de Vue Router (route courante)
 * @param {Object} additionalParams - Paramètres supplémentaires à ajouter
 * @returns {String} URL complète avec paramètre from
 */
export function buildUrlWithPreservedParams(path, route, additionalParams = {}) {
  const params = {
    from: route.path,
    ...additionalParams
  }

  const queryString = Object.entries(params)
    .filter(([, value]) => value !== null && value !== undefined && value !== '')
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&')

  return queryString ? `${path}?${queryString}` : path
}

/**
 * Récupère le paramètre "from" depuis la route courante.
 * @param {Object} route - L'objet route de Vue Router
 * @returns {String} Le chemin d'origine ou '/' par défaut
 */
export function getFromParam(route) {
  return route.query.from || '/'
}
